export default "__VITE_PUBLIC_ASSET__65a10d84__"